import './Footer.css'

const Footer = () => (
  <footer className='footer'>
      Created By Ethan Aikman
  </footer>
)

export default Footer
